import React, { createContext } from 'react';
import { GetPersistedFilters, useGetPersistedFilters } from './UseGetPersistedFilters';

export const UserPersistedFiltersContext = createContext<GetPersistedFilters>({} as GetPersistedFilters);

export const UserPersistedFiltersProvider = ({ children }: { children?: React.ReactNode }): JSX.Element => {
  const getValues = useGetPersistedFilters();
  return <UserPersistedFiltersContext.Provider value={getValues}>{children}</UserPersistedFiltersContext.Provider>;
};
